import { siteState } from '@/modules/siteState/siteStateGetter';

const props = {
  cursorId: 'js-mouseStalker',
  cursorSelector: '[data-cursor]',
  htmlClassPrefix: 'is-cursor',
  ease: 0.15,
} as const;

const state = {
  cursorEl: null as HTMLElement | null,
  targetElements: [] as HTMLElement[],

  handlers: {
    mouseMove: null as ((e: MouseEvent) => void) | null,
    elements: new Map<HTMLElement, { enter: () => void; leave: () => void }>(),
  },

  mouse: {
    x: 0,
    y: 0,
  },
  current: {
    x: 0,
    y: 0,
  },

  currentCursorType: '',
  rafId: null as number | null,
};

export const mouseStalker = {
  init() {
    if (!siteState.isHover) return;

    state.cursorEl = document.getElementById(props.cursorId);

    if (!state.cursorEl) return;

    state.targetElements = Array.from(document.querySelectorAll<HTMLElement>(props.cursorSelector));

    this.bindEvents();
    this.startRaf();
  },

  bindEvents() {
    // mousemoveハンドラーを保存
    state.handlers.mouseMove = (e: MouseEvent) => this.onMouseMove(e);
    document.addEventListener('mousemove', state.handlers.mouseMove);

    // 各要素のハンドラーを保存
    state.targetElements.forEach((el) => {
      const enterHandler = () => this.onElementEnter(el);
      const leaveHandler = () => this.onElementLeave();

      state.handlers.elements.set(el, { enter: enterHandler, leave: leaveHandler });

      el.addEventListener('mouseenter', enterHandler);
      el.addEventListener('mouseleave', leaveHandler);
    });
  },

  unbindEvents() {
    // mousemoveハンドラーを削除
    if (state.handlers.mouseMove) {
      document.removeEventListener('mousemove', state.handlers.mouseMove);
      state.handlers.mouseMove = null;
    }

    // 各要素のハンドラーを削除
    state.handlers.elements.forEach((handlers, el) => {
      el.removeEventListener('mouseenter', handlers.enter);
      el.removeEventListener('mouseleave', handlers.leave);
    });
    state.handlers.elements.clear();
  },

  onMouseMove(e: MouseEvent) {
    state.mouse.x = e.clientX;
    state.mouse.y = e.clientY;
  },

  onElementEnter(el: HTMLElement) {
    const cursorType = el.getAttribute('data-cursor');
    if (cursorType) {
      state.currentCursorType = cursorType;
      document.documentElement.classList.add(`${props.htmlClassPrefix}${cursorType}`);
    }
  },

  onElementLeave() {
    if (state.currentCursorType) {
      document.documentElement.classList.remove(`${props.htmlClassPrefix}${state.currentCursorType}`);
      state.currentCursorType = '';
    }
  },

  startRaf() {
    this.stopRaf();
    state.rafId = requestAnimationFrame(() => this.runRaf());
  },

  runRaf() {
    if (!state.cursorEl) return;

    state.current.x += (state.mouse.x - state.current.x) * props.ease;
    state.current.y += (state.mouse.y - state.current.y) * props.ease;

    state.cursorEl.style.transform = `translate(${state.current.x}px, ${state.current.y}px)`;

    state.rafId = requestAnimationFrame(() => this.runRaf());
  },

  stopRaf() {
    if (state.rafId !== null) {
      cancelAnimationFrame(state.rafId);
      state.rafId = null;
    }
  },

  reset() {
    this.stopRaf();
    this.unbindEvents();

    if (state.cursorEl) {
      state.cursorEl.style.transform = '';
    }
    if (state.currentCursorType) {
      document.documentElement.classList.remove(`${props.htmlClassPrefix}${state.currentCursorType}`);
      state.currentCursorType = '';
    }

    // targetElementsもクリア
    state.targetElements = [];
  },
};
